import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Button from 'components/Button/Button';

interface IBlockMenuItemRemoveButtonProps {
  blockType: string;
  title: string;
  onRemove: () => void;
}

export const BlockMenuItemRemoveButton: React.FC<
  IBlockMenuItemRemoveButtonProps
> = ({ blockType, title, onRemove }) => {
  const handleClick = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    onRemove();
  };

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={handleClick}
      className="p-1 h-auto w-auto hover:bg-gray-100 rounded transition-colors opacity-0 group-hover/collapsible:opacity-100"
      title={title}
      data-testid={`TemplatesStudio-BlockRemove-${blockType}`}
    >
      <FontAwesomeIcon
        icon="fa-regular fa-trash"
        className="text-sm text-base-mutedForeground hover:text-gray-700"
      />
    </Button>
  );
};
